import { render, staticRenderFns } from "./InvoiceProjectView.vue?vue&type=template&id=451670ad&scoped=true&"
import script from "./InvoiceProjectView.vue?vue&type=script&lang=js&"
export * from "./InvoiceProjectView.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceProjectView.vue?vue&type=style&index=0&id=451670ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451670ad",
  null
  
)

export default component.exports